import update from 'immutability-helper';
import {
  APP_ERROR,
  UPDATE_BRANCH_LINK,
  SET_BRANCH_SHOWING_STATUS,
  UPDATE_MW_BYPASS_COOKIE,
  SET_SHOW_PAIRING_SUCCESS_PAGE,
  SET_DO_NOT_ASK_TO_DELETE_DEVICE,
  SET_TOP_BANNER_HEIGHT,
  SET_ONETRUST_GDPR_DATA,
  OPEN_ONETRUST_BANNER_ON_INIT,
  ALLOW_AUTOPLAY,
  DISALLOW_AUTOPLAY,
  UPDATE_BREAKPOINT,
} from '../actions/app';
import createMappedReducer from './utils/createMappedReducer';

export function getInitialState() {
  return {
    partnerId: '',
    branchUrl: '',
    isBranchBannerShowing: false,
    userAgent: '',
    isDesktop: false,
    isMobile: false,
    enableBetaFeatures: false,
    enableFavorites: true,
    errors: [],
    oneTrust: {
      gdpr: { isOptedOut: true, hasConsentBeenCaptured: false },
      openSettingsDialogOnInit: false,
    },
    doNotAskToDeleteDevice: false,
    desktopVersion: undefined,
    desktopOS: undefined,
    topBannerHeight: 0,
    allowAutoplay: false,
    debug: { showActionLogs: true },
  };
}

export const app = createMappedReducer(getInitialState(), {
  [APP_ERROR]: (state, action) =>
    update(state, {
      errors: {
        $push: [action.payload],
      },
    }),
  [UPDATE_BRANCH_LINK]: (state, action) =>
    update(state, {
      branchUrl: { $set: action.branchUrl },
    }),
  [SET_BRANCH_SHOWING_STATUS]: (state, action) =>
    update(state, {
      isBranchBannerShowing: { $set: action.isShowing },
    }),
  [UPDATE_MW_BYPASS_COOKIE]: (state, action) =>
    update(state, {
      mwLandingBypassCookieVal: { $set: action.value },
    }),
  [SET_SHOW_PAIRING_SUCCESS_PAGE]: (state, action) =>
    update(state, {
      showPairingSuccessPage: { $set: action.shouldShowPairingSuccessPage },
    }),
  [SET_ONETRUST_GDPR_DATA]: (state, action) =>
    update(state, {
      oneTrust: { gdpr: { $merge: action.gdprData } },
    }),
  [OPEN_ONETRUST_BANNER_ON_INIT]: (state) =>
    update(state, {
      oneTrust: { openSettingsDialogOnInit: { $set: true } },
    }),
  [SET_TOP_BANNER_HEIGHT]: (state, action) =>
    update(state, {
      topBannerHeight: { $set: action.height },
    }),
  [SET_DO_NOT_ASK_TO_DELETE_DEVICE]: (state) =>
    update(state, {
      doNotAskToDeleteDevice: { $set: true },
    }),
  [ALLOW_AUTOPLAY]: (state) =>
    update(state, {
      allowAutoplay: { $set: true },
    }),
  [DISALLOW_AUTOPLAY]: (state) =>
    update(state, {
      allowAutoplay: { $set: false },
    }),
  [UPDATE_BREAKPOINT]: (state, action) =>
    update(state, {
      breakpoint: { $set: action.breakpoint },
    }),
});
